import { styledComponent } from 'lib/styled_component';
import { Backdrop } from 'aa-react-ui';

const FadedBackdrop = styledComponent(Backdrop)`
    opacity: 0.4;
`;

export default FadedBackdrop;
